<div class="navigator-container" *ngIf="show">
    <div class="navigator-container__item"
        *ngFor="let view of navigatorViews"
        (click)="goToPath(view.path)"
        [ngClass]="{'active-route': isRouteActive(view.path)}">
            {{view.name + '.title' | transloco}}
    </div>
</div>
